import React, { useEffect, useRef, useState } from "react";


const List = ({question, answer, IsOpen, onClick, minus_white,plus, border_color, hr_color}) => {

    const spanRef = useRef(null);
    const [isTall, setIsTall] = useState(false);
  
    useEffect(() => {
      if (spanRef.current) {
        const height = spanRef.current.offsetHeight;
        setIsTall(height > 49);
      }
    }, []);

    return(
        <div
            className={`relative my-3 flex flex-col justify-between items-center cursor-pointer transition-[max-height] duration-300 ease-in-out ${IsOpen ? "max-h-[200px] pt-2" : "max-h-[65px] pt-2"} ${
                isTall ? "pt-0" : "pt-2"
                }`}
            onClick={onClick}
            
            >
                <hr
                    className={`absolute left-0 w-full h-[2px] transition-all duration-300 ${
                    IsOpen ? "top-[calc(100%-1px)]" : "top-[calc(100%)]"
                    }
                    ${
                        isTall ? "mt-2" : "mt-0"
                        }
                    `}
                    style={{backgroundColor: hr_color}}
                />
                <div className={`lg:text-[24px] xs:text-[20px] text-[16px] flex justify-between items-center w-full ${
                isTall ? "mb-2" : "mb-0"
                }`}>
                    <span 
                    ref={spanRef}
                    >{question}</span>
                    <div style={{borderColor: border_color}} className={`ml-2 min-w-[40px] min-h-[40px] transition-all border-[1px] flex items-center justify-center rounded-full ${
                isTall ? "mb-2" : "mb-0"
                }
                ${IsOpen ? "bg-black" : ""}`}>

                    {IsOpen ? <img src={minus_white} alt="-" /> : <img src={plus} alt="+"/>}
                
                    </div>

                </div>
            
            <span className={`text-[16px] transition-all mt-2 duration-500 ${IsOpen ? "opacity-100 mb-2" : "opacity-0"} ${
                isTall ? "mt-0" : "mt-2"
                }`} >{answer}</span>
        </div>
    );
};

export default List;